import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/qrcode/:id',
        name: RoutesEnum.QRCODE.INDEX,
        view: 'qrcode/Qrcode',
        meta: {
            layout: 'plain',
            title: 'Bookeraj - Rezerviši i Pruži Usluge Online',
            description:
                'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.',
        },
    },
]
